module.exports = __webpack_public_path__ + "img/松井澄香.cdf99764.jpg";